import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Icon, Input } from 'antd'
import memoizeOne from 'memoize-one';

import { filterArrayBySearchText } from '../../../data/config/utils'

const CheckboxGroup = Checkbox.Group;
const Search = Input.Search;

class CheckboxGroupItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      show_search_input: false,
      show_all_options: false,
      display_options_count: props.display_count,
      filtered_options: props.options,
      select_all: props.checked_items && props.checked_items.length === props.options.length,
      indeterminate: props.checked_items && !!props.checked_items.length && (props.checked_items.length < props.options),
    };
  }

  componentDidUpdate(prevProps) {
    const { checked_items } = this.props;
    const { select_all, indeterminate } = this.state;
    if (prevProps.checked_items && prevProps.checked_items.length > 0 && checked_items && checked_items.length === 0 && (select_all || indeterminate)) {
      if (select_all)
        this.setState({ select_all: false })
      if (indeterminate)
        this.setState({ indeterminate: false })
    }
  }

  showAllOptions = () => {
    const { filtered_options } = this.state;
    this.setState({
      show_all_options: true,
      display_options_count: filtered_options.length,
    });
  }

  showLessOptions = () => {
    const { display_count } = this.props;
    this.setState({
      show_all_options: false,
      display_options_count: display_count,
    });
  }

  showSearchInput = () => {
    this.setState({
      show_search_input: true,
    });
  }

  hideSearchInput = () => {
    const { options } = this.props
    this.setState({
      show_search_input: false,
      filtered_options: options
    });
  }

  onOptionsSearch = event => {
    const { options, is_object_type_options, select_option_object } = this.props;
    this.setState({
      filtered_options: is_object_type_options || select_option_object ? filterArrayBySearchText(event.target.value, options, 'label') : filterArrayBySearchText(event.target.value, options)
    })
  }

  onChangeCheckboxGroup = checked_items => {
    const { options, onChange } = this.props;
    this.setState({
      indeterminate: !!checked_items.length && (checked_items.length < options.length),
      select_all: checked_items.length === options.length,
    }, () => onChange(checked_items));
  }

  onChangeSelectAll = e => {
    const { options, onChange, is_object_type_options } = this.props;
    const select_all = e.target.checked;
    let checked_items = [];
    if (select_all) {
      if (is_object_type_options) {
        for (let i = 0; i < options.length; i++) {
          checked_items[i] = options[i].value;
        }
      } else {
        checked_items = options;
      }
    }
    this.setState({
      select_all,
      indeterminate: false,
    }, () => onChange(checked_items));
  }

  getCheckboxOptions = memoizeOne((show_all_options, filtered_options) => {
    const { display_options_count } = this.state;
    if (show_all_options)
      return filtered_options;
    else
      return filtered_options.slice(0, display_options_count);
  })

  render() {
    const {
      title,
      title_class,
      container_class,
      options,
      show_search,
      checked_items,
      select_option_object
    } = this.props;
    const { select_all, indeterminate, display_options_count, show_all_options, filtered_options, show_search_input } = this.state;
    if (options.length > 0) {
      const checkbox_options = this.getCheckboxOptions(show_all_options, filtered_options);
      return (
        <div className={container_class}>
          <div className="ori-flex-row ori-flex-wrap ori-flex-jsb ori-tb-mrgn-5 ori-font-default">
            {
              title &&
              <p className={`ori-b-mrgn-5 ori-capitalize-first ${title_class}`}>{title}</p>
            }
            <div>
              {
                show_search && !show_search_input &&
                <Icon className="ori-r-mrgn-10 ori-cursor-ptr" type="search" onClick={this.showSearchInput} />
              }
              {
                show_search && show_search_input &&
                <Icon className="ori-r-mrgn-10 ori-cursor-ptr" type="close" onClick={this.hideSearchInput} />
              }
              <Checkbox className="ori-b-mrgn-5 ori-font-default ori-font-normal" indeterminate={indeterminate} checked={select_all} onChange={this.onChangeSelectAll}>Select All</Checkbox>
            </div>
          </div>
          {
            show_search_input &&
            <Search className="ori-b-mrgn-5" placeholder="search" onChange={this.onOptionsSearch} />
          }
          {
            filtered_options.length === 0 &&
            <span className="ori-font-light ori-font-xs ">Not found</span>
          }
          {
            select_option_object ?
              <CheckboxGroup
                value={checked_items}
                onChange={this.onChangeCheckboxGroup}
              >
                {
                  checkbox_options.map((option, index) => {
                    return (
                      <Checkbox
                        key={index}
                        className="ori-display-block ori-font-xs ori-font-light ori-no-l-mrgn"
                        value={option}
                      >
                        {option.label}
                      </Checkbox>
                    );
                  })
                }
              </CheckboxGroup>
              :
              <CheckboxGroup
                className="ori-full-width ori-checkbox-group-item-vertical"
                options={checkbox_options}
                value={checked_items}
                onChange={this.onChangeCheckboxGroup}
              />
          }
          {
            !show_all_options && filtered_options.length > display_options_count &&
            <div
              className="ori-font-primary ori-cursor-ptr ori-t-mrgn-5 ori-font-xs"
              onClick={this.showAllOptions}
            >
              {`show ${filtered_options.length - display_options_count} more `}
            </div>
          }
          {
            show_all_options && filtered_options.length >= display_options_count &&
            <div
              className="ori-font-primary ori-cursor-ptr ori-t-mrgn-5 ori-font-xs"
              onClick={this.showLessOptions}
            >
              show less
            </div>
          }
        </div>
      );
    } else return null;
  }
}

CheckboxGroupItem.propTypes = {
  title: PropTypes.string,
  title_class: PropTypes.string,
  container_class: PropTypes.string,
  options: PropTypes.array.isRequired,
  checked_items: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  display_count: PropTypes.number,
  show_search: PropTypes.bool,
  is_object_type_options: PropTypes.bool,
  select_option_object: PropTypes.bool,
};

CheckboxGroupItem.defaultProps = {
  container_class: "ori-tb-pad-5",
  options: [],
  checked_items: [],
  onChange: () => { },
  display_count: 6,
  show_search: false,
  is_object_type_options: false, // use either is_object_type_options or select_option_object
  select_option_object: false
};

export default CheckboxGroupItem;



// WEBPACK FOOTER //
// ./src/components/form/checkboxgroupitem/index.js